import React from 'react';
import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi';

const Pagination = ({ currentPage, totalPages, onPageChange, showPageCount = true }) => {
    const selectedStyle = {
        backgroundColor: '#2121F11A', color: '#2121F1', padding: '3px 10px', borderRadius: '5px'
    };
    const pagesToShow = 1;
    let startPage = Math.max(currentPage - pagesToShow, 1);
    let endPage = Math.min(currentPage + pagesToShow, totalPages);

    const handlePageClick = (page) => {
        onPageChange(page);
    };

    return (
        <div className="flex items-center justify-between">
            {showPageCount ? <div className="font-dmsans text-[13px]">Page {currentPage} of {totalPages}</div> : <></> }
            <div className="table-controlle-container flex items-center justify-between">
                <div className="text-[#2121F1] flex items-center space-x-2">
                    <HiOutlineChevronLeft className="cursor-pointer" onClick={()=>{
                         if(currentPage != 1){
                            handlePageClick(currentPage - 1);
                         }
                    }}/>
                    <div className="flex items-center space-x-2 select-none"
                            id="pagination-container">
                                {currentPage > 2 && <span>1</span>}
                                {currentPage > 3 && <span>...</span>}
                                {[...Array(endPage - startPage + 1)].map((_, index) => (
                                    <span
                                        key={startPage + index}
                                        style={{ ...(startPage + index === currentPage ? { ...selectedStyle } : {}) }}
                                    >
                                        {startPage + index}
                                    </span>
                                ))}
                                {endPage < totalPages && <span>...</span>}
                                {endPage !== totalPages && <span>{totalPages}</span>}
                    </div>
                    <HiOutlineChevronRight className="cursor-pointer" onClick={()=>{
                        if(currentPage != totalPages){
                           handlePageClick(currentPage + 1);
                        }
                    }}/>
                </div>
            </div>
        </div>
    );
};

export default Pagination;
